import { FeaturesModel, SkusModel, MediaModel, ProviderModel, TemplateModel } from './index';

export interface SEO {
  title?: string;
  description?: string;
}
export class ProductModel {
  seo?: SEO;
  active: boolean;
  longDescription: string;
  tncUrl: string;
  endDate: string;
  startDate: string;
  configurations: any[];
  features: FeaturesModel[];
  plainDescription: string;
  subDescription: string;
  skus: SkusModel[];
  productContent: any;
  media: MediaModel;
  provider: ProviderModel;
  displayName: string;
  id: string;
  site: string;
  dmcCode: string;
  productInfoUrl: string;
  shortDescription: string;
  shortDescription1: string;
  shortDisplayInfo: string;
  basicPrice: string;
  template: TemplateModel[];
  quantity: number;
  learnMessage: string;
  packageLabelName: string;
  bannerName: string;
  details: Array<String>;
  EasyDeploydetails: Array<String>;
  firstNote: String;
  secondNote: String;
  thirdNote: String;
  moreInfoHeader: String;
  requirements: Array<String>;
  tabsList: Array<String>;
  authTabsList:Array<String>;
  forMoreInformation: String;
  forMoreInformation1: String;
  forMoreInformation2: String;
  noFansMessage: String;
  noPermissionMessage: String;
  bannerButtonLabelInitial: String;
  bannerButtonAuthLabel : String;
  bannerButtonLabelEnroll: String;
  bannerButtonLabelDashboard: String;
  lightBackground: any;
  benefitsHeading: any;
  benefitsText: any;
  noCIPermissionMessage: String;
  programsHeading: string
  firstNetErrorMessagefirstPart: String;
  firstNetErrorMessageSecondPart:String;
  myAttErrorMessageFirstPart:String;
  myAttErrorMessageSecondPart:String;
  // Default constructor will be called by mapper
  constructor() {
    this.active = undefined;
    this.longDescription = undefined;
    this.tncUrl = undefined;
    this.endDate = undefined;
    this.startDate = undefined;
    this.configurations = undefined;
    this.features = undefined;
    this.skus = undefined;
    this.productContent = undefined;
    this.media = undefined;
    this.provider = undefined;
    this.displayName = undefined;
    this.id = undefined;
    this.shortDescription = undefined;
    this.shortDescription1 = undefined;
    this.shortDisplayInfo = undefined;
    this.basicPrice = undefined;
    this.template = undefined;
    this.productInfoUrl = undefined;
    this.dmcCode = undefined;
    this.plainDescription = undefined;
    this.subDescription = undefined;
    this.quantity = undefined;
    this.learnMessage = undefined;
    this.packageLabelName = undefined;
    this.lightBackground = undefined;
    this.benefitsHeading = undefined;
    this.benefitsText = undefined;
  }

}

